import { HSMSLoading, HSMSPageHeaderWrapper, HSMSStepContentCard, PageBreadcrumbs } from '@components/shared';
import { Empty, PageHeader } from 'antd';
import { ResultSheetConfiguration, ResultSheetStudents, resultSheetTourSteps } from '@modules/resultSheet';
import React, { useState } from 'react';
import { batchesForResultSheetQuery, batchSubjectConfigurationForResultSheetQuery } from '@app-types/graphql-types';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react';
import { useMst } from '@models/Root';
import { AppTours } from '@modules/app';

export const ManageResultSheet = observer(() => {
  const [selectedBatch, setSelectedBatch] = useState<batchesForResultSheetQuery['batch'][0]>();
  const [selectedBatchClass, setSelectedBatchClass] = useState<
    batchesForResultSheetQuery['batch'][0]['batch_classes'][0]
  >();
  const [selectedSubject, setSelectedSubject] = useState<
    batchSubjectConfigurationForResultSheetQuery['batch_subject_configuration'][0]
  >();
  const router = useRouter();
  const { semesterId } = useMst().resultSheet;

  const { id: resultSheetId } = router.query;

  return (
    <div>
      <HSMSPageHeaderWrapper>
        <PageHeader title="Result Sheet " subTitle="Enter individual student marks" />
      </HSMSPageHeaderWrapper>

      <PageBreadcrumbs
        paths={[
          {
            pathName: 'Result Sheets',
            url: '/result-sheets',
          },
          {
            pathName: `${resultSheetId ? 'Update' : 'Create'} Result Sheet`,
          },
        ]}
      />

      <AppTours steps={resultSheetTourSteps.manageResultSheet} />

      <HSMSStepContentCard>
        <div className="hsms-card-body">
          {(resultSheetId ? !!semesterId : true) ? (
            <ResultSheetConfiguration
              selectedBatch={selectedBatch}
              setSelectedBatch={setSelectedBatch}
              selectedBatchClass={selectedBatchClass}
              setSelectedBatchClass={setSelectedBatchClass}
              selectedSubject={selectedSubject}
              setSelectedSubject={setSelectedSubject}
            />
          ) : (
            <HSMSLoading height={100} size="default" />
          )}
        </div>
      </HSMSStepContentCard>

      <HSMSStepContentCard>
        <div className="hsms-card-body">
          {!resultSheetId && !selectedSubject ? (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a class first" />
          ) : (
            <ResultSheetStudents selectedBatchClass={selectedBatchClass} selectedSubject={selectedSubject} />
          )}
        </div>
      </HSMSStepContentCard>
    </div>
  );
});
